import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../redux/actions'
import Interface from '../components/Interface'

class Closet extends Component {
  render () {
    return (
      <Interface logoImg='assets/closet.png' title='Não encontrado' history={this.props.history}>
        <div>
          <span id='not-found-txt' >Desculpe, a página que você procurou não foi encontrada </span>
        </div>
      </Interface>
    )
  }
}

const mapStateToProps = (state) => {
  return {}
}

export default connect(mapStateToProps, actions)(Closet)



// WEBPACK FOOTER //
// ./src/containers/NotFound.js